// extracted by mini-css-extract-plugin
export default {"menu-background-color":"MenuBar_menu-background-color__9WTmr","mobile-xmenu-icon":"MenuBar_mobile-xmenu-icon__C1dUf"};